import {
  KEY__TABLE_COLLECTION__VIEW_TYPE__CANDIDATE
} from '../../../dictionaries/TableCollectionKeys.dic';
import getCandidateEntityName from '../../../lib/Candidate/getCandidateEntityName.fun';
import Box from '../../Layout/Wrappers/Box';
import TableCollection from '../../Layout/Wrappers/TableCollection';

export function CandidateEngagementsDetails({
  candidate = {},
  isDrawer = false,
  ...props
}) {
  return (
    <TableCollection
      {...props}
      where={{ candidateId: candidate.id }}
      title={
        <Box row w100 className='bg-white f-lg p-2'>
          <div className='fw-600 c-cyan-darker mr-1'>
            Engagements for candidate:
          </div>
          <span className='c-black'>
            {getCandidateEntityName(candidate)}
          </span>
        </Box>
      }
      isDrawer={isDrawer}
      viewType={KEY__TABLE_COLLECTION__VIEW_TYPE__CANDIDATE}
    />
  );
}
